import { render, staticRenderFns } from "./bank-account-report.vue?vue&type=template&id=16d661b2&"
import script from "./bank-account-report.vue?vue&type=script&lang=js&"
export * from "./bank-account-report.vue?vue&type=script&lang=js&"
import style0 from "./bank-account-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports